module.exports = __webpack_public_path__ + "33a677ee3d5327407771fe42fe980932.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loading.gif
// module id = 779
// module chunks = 0